import react,{useEffect} from 'react';
import { useLocation } from 'react-router-dom';
import { useState } from 'react';
import axios from 'axios';
import { withGoogleMap, withScriptjs, GoogleMap, Polyline, Marker } from 'react-google-maps';

const Map = () => {
  const location = useLocation();
  const { state } = location;
  const { selectedId } = state;
  const [thePath,setThePath]=useState([])
  const [la, setLa] = useState(0);
  const [ln, setLn] = useState(0);
  const [ready, setReady] = useState(false);

  // console.log(la,ln)
  useEffect(() => {
        const mashawiritoken = localStorage.getItem('mashawiritoken');

        const fetchData = async () => {
            try {
              const response = await axios.get(`${process.env.REACT_APP_API_URL}get_path/${selectedId}`, {
                headers: {
                  Authorization: `Bearer ${mashawiritoken}`,
                },
              });
              setThePath(response.data.data)
           
                  setLa(parseFloat(response.data.data[0].lat));
                  setLn(parseFloat(response.data.data[0].lng));
                
                setReady(true)
            } catch (error) {
              console.error(error);
            }
          };
      
          fetchData();
        
  }, []);

return(
    <>
    {ready &&
     <GoogleMap defaultZoom={19} defaultCenter={{ lat : la , lng : ln }}>
          <Polyline path={thePath} options={{ strokeColor: '#11D904',strokeWeight:'4' }} />
    </GoogleMap>
    }
    </>
  )
};


const MapComponent = withScriptjs(withGoogleMap(Map));

export default () => (
  <MapComponent
    googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyC29UPPPbYU6EsOx25Y_mohvE4ZNut4Yx8"
    loadingElement={<div style={{ height: '100%' }} />}
    containerElement={<div style={{ height: '700px', width: '100%' }} />}
    mapElement={<div style={{ height: '100%' }} />}
  />
);


